import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import { ackOverrun } from "@data/redux/actions/liveMode"
import { isOverrunAcknowledged } from "@data/redux/reducers/data/tutorOverrunAck"
import { buildTutorOverrunCopy } from "../tutorOverrunCopy"

/**
 * Pop-up montré au tuteur encore dans sa salle précédente quand sa séance
 * suivante a commencé (`tutor_overrun`, relu au poll de sa salle). Même forme
 * qu'`InitialDialog` : rien n'est rendu, `DialogM.show()` affiche. Un bouton ;
 * acquitté, il ne revient plus pour cette occurrence, même après rechargement.
 */
export function TutorOverrunDialog({ tutorOverrun }) {
    const dispatch = useDispatch()
    const occurrenceId = tutorOverrun?.next_occurrence_id
    const acknowledged = useSelector((state) =>
        isOverrunAcknowledged(state.data.tutorOverrunAck, occurrenceId)
    )
    const shouldShow = !!occurrenceId && !acknowledged

    // Une fois par occurrence : le payload, relu chaque minute, n'est pas une
    // dépendance — il ne doit pas rouvrir un pop-up déjà montré.
    useEffect(() => {
        if (!shouldShow) return

        const copy = buildTutorOverrunCopy({
            nextSessionTimeLabel: tutorOverrun.next_occurrence_label,
            waitingStudents: tutorOverrun.p1_names,
            stayedStudents: tutorOverrun.p2_names,
        })
        if (!copy) return

        const acknowledge = () => dispatch(ackOverrun(occurrenceId))
        DialogM.show({
            champion: "abou",
            text1: copy.text1,
            text2: copy.text2,
            buttonText1: copy.buttonText1,
            onPress: acknowledge,
            exitButton: true,
            onPressBack: acknowledge,
        })
    }, [shouldShow, occurrenceId, dispatch])

    return null
}
